module.exports = __webpack_public_path__ + "img/3.a2e5b8b9.jpg";